import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../common/alert.service';
import { AppService, DCO, GetDCOsRequest, RuntimeAppSetting, SaveDCORequest, SaveRuntimeAppSettingRequest, AppSetting, GetDCOsResponse, GetRuntimeAppSettingsRequest } from '../../app.service';
import { LoadingService } from '../../common/loading.service';
import { MatDialog } from '@angular/material/dialog';
import { catchError, finalize, map, Observable, of, tap } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-user-admin',
  templateUrl: './user-admin.component.html',
  styleUrl: './user-admin.component.scss'
})
export class UserAdminComponent implements OnInit {

  public form: FormGroup;
  public systemAccountDCOFormControl: FormControl;

  public activeDcos: DCO[] = [];
  public selectedDco: DCO = null;
  public savedDco: RuntimeAppSetting = null;
  constructor(
    private service: AppService,
    private alert: AlertService,
    private spinner: LoadingService,
    private dialog: MatDialog,
  ) { }


  ngOnInit(): void {
    this.getDCOs().subscribe(() => {
      this.loadSystemAccountDCO(); // Call this after DCOs are loaded
    });
    this.initForm();
  }

  private initForm() {
    this.form = new FormGroup({});
    this.systemAccountDCOFormControl = new FormControl('', [Validators.required]);

    this.form.addControl('systemAccountDCOFormControl', this.systemAccountDCOFormControl);
  }

  private getDCOs(): Observable<DCO[]> {
    const request = new GetDCOsRequest();
    request.activeOnly = true;

    // Show the spinner before the request starts
    this.spinner.show();

    return this.service.GetDCOs(request).pipe(
      map((result: GetDCOsResponse) => {
        if (result.success) {
          this.activeDcos = result.dcos;
          return result.dcos; // Return the DCO array
        } else {
          console.log(`ERROR: ${result.message}`);
          return []; // Return an empty array in case of failure
        }
      }),
      catchError((error) => {
        console.error(error);
        return of([]); // Return an empty array or appropriate fallback in case of error
      }),
      finalize(() => {
        // Hide the spinner after the request completes
        this.spinner.hide();
      })
    );
  }

  private loadSystemAccountDCO() {
    const request = new GetRuntimeAppSettingsRequest();
    request.name = AppSetting.SystemAccountDCO;

    this.service.GetRuntimeAppSettings(request)
      .pipe(
        finalize(() => {
          // Hide the spinner after the request completes
          this.spinner.hide();
        })
      )
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.savedDco = response.settings[0];

            if (this.savedDco) {
              const mappedDCO = this.activeDcos.find(d => d.name == this.savedDco.value);
              if (mappedDCO) {
                this.systemAccountDCOFormControl.setValue(mappedDCO);
              }
            }



          } else {
            this.alert.warning(response.message);
          }
        },
        error: (error) => {
          console.error('Error retrieving system account DCO:', error);
          this.alert.error('Error retrieving system account DCO.');
        }
      });
  }



  public onSaveSystemAccountDco(): void {
    if (this.form.valid) {

      this.spinner.show();
      const request = new SaveRuntimeAppSettingRequest();

      const runtimeAppSetting = new RuntimeAppSetting();
      runtimeAppSetting.name = AppSetting.SystemAccountDCO;
      runtimeAppSetting.value = this.systemAccountDCOFormControl.value.name;

      request.setting = runtimeAppSetting;

      console.log(request);

      this.service.SaveRuntimeAppSetting(request)
        .pipe(
          finalize(() => {
            // Hide the spinner after the request completes
            this.spinner.hide();
          })
        )
        .subscribe({
          next: (response) => {
            if (response.success) {
              this.alert.success('System account DCO saved successfully!');

            } else {
              this.alert.warning(response.message);
            }
          },
          error: (error) => {
            console.error('Error submitting system account DCO:', error);
            this.alert.error('Error submitting system account DCO.');
          }
        });
    } else {
      // Mark all fields as touched to show validation errors
      this.form.markAllAsTouched();
      this.alert.warning('Please correct the errors in the form before submitting.');
    }
    
  }
}
